import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../store';

import Radio from '../common/radio';
import {get24HrPointTime, getRouteInfo} from '../../common/common';

import PassDetails from '../passDetails/PassDetails';
import ComDetails from '../comDetails/ComDetails';

import { saveEditDetails, toggleFinalSave } from '../../actions/editPolicy-actions';

class DropOff extends Component {
    constructor(props){
        super(props);
        this.state = {
            dropOff:true,
            selDropOff:[],
            selDropoffName:'',
            passDetails:false, 
            comDetails:false 
        };
    }

    componentDidMount() {
        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        this.setState({selDropoffName : APIGetBookingDetailsResult.DropoffName});
        this.props.editPolicy.pickups.length===0 && getRouteInfo(APIGetBookingDetailsResult.RouteCode);
    }

    closeSlider = (name,value) => {
        this.setState({[name]:value});
    }

    showDropOffPointFn = () => {
        const loop = this.props.editPolicy.dropPoints;
        return(
            <div>
                <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                    <span className='back-arrow' onClick = { () => { this.props.closeSlider('dropOff',false); store.dispatch(toggleFinalSave(false)) }} >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"/>
                        </svg>
                    </span>
                    <span className='header-title'>
                        Dropoff Locations
                    </span>
                </div>
                <div className='ep-wrapper' style={{background:'#fff', zIndex:'7'}}>
                    <div className='dropOff-wrapper'>
                        { loop.map((el, index) => {
                            return(
                                <div key = { index }>
                                    <Radio
                                        value = {el['DropoffName'] }
                                        showValue = {el['DropoffName'] }
                                        name = 'DropoffName'
                                        checked = { el['DropoffName'] === this.state.selDropoffName }
                                        handleChange = {() => this.setState({selDropoffName : el['DropoffName'],selDropOff:el}) }
                                    />
                                    <span className='pickUpTime'>{get24HrPointTime(el['DropoffTime'] )}</span>
                                </div>
                            )
                        }) }
                    </div>
                    <div className='btn' style={{ position:'fixed',left:'0',bottom:'0',background: window.color['buttonColor']}} onClick={()=>this.checkEditOption()}>
                        PROCEED
                    </div>
                </div>
            </div>
        )
    }

    checkEditOption = () => {
        let editDetails = this.props.editPolicy.editDetails;

        editDetails['dropoff'] = this.state.selDropOff ? this.state.selDropOff : '';

        if(this.state.selDropOff.length === 0){
            this.props.editPolicy.dropPoints.forEach(el => {
                if(el['DropoffName'] === this.state.selDropoffName){
                    this.setState({selDropOff : el});
                    editDetails['dropoff'] = el;
                }
            });
        }

        store.dispatch(saveEditDetails(editDetails));

        const editOptions = this.props.editPolicy.editOptions;
        let flag =0;
        for (var i = 0; i < editOptions.length; i++) {
            let el = editOptions[i];
            if(el.value === 'on' && el.name !== 'seatChart' && el.name !== 'pickUp' && el.name !== 'dropOff') {
                this.setState({ [el.name]:true});
                flag =1;
                break;
            }
        }
        if(flag === 0) {
            store.dispatch(toggleFinalSave(true)); 
        }
    }

	render() {
    	return (
            <div>
                {this.state.dropOff && this.showDropOffPointFn() }
                {this.state.passDetails && <PassDetails closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
                {this.state.comDetails && <ComDetails closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
            </div>
        );
  	}
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(DropOff);


// WEBPACK FOOTER //
// ./src/components/dropOff/DropOff.js